import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var a = Object.defineProperty;
var r = (e, c, t) => c in e ? a(e, c, {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: t
}) : e[c] = t;
var p = (e, c, t) => (r(e, typeof c != "symbol" ? c + "" : c, t), t);
import { Machine as d } from '../machine.js';
import { DefaultMap as l } from '../utils/default-map.js';
import { match as u } from '../utils/match.js';
var k = (t => (t[t.Push = 0] = "Push", t[t.Pop = 1] = "Pop", t))(k || {});
let y = {
  [0](e, c) {
    let t = c.id,
      s = e.stack,
      i = e.stack.indexOf(t);
    if (i !== -1) {
      let n = e.stack.slice();
      return n.splice(i, 1), n.push(t), s = n, _objectSpread(_objectSpread({}, e), {}, {
        stack: s
      });
    }
    return _objectSpread(_objectSpread({}, e), {}, {
      stack: [...e.stack, t]
    });
  },
  [1](e, c) {
    let t = c.id,
      s = e.stack.indexOf(t);
    if (s === -1) return e;
    let i = e.stack.slice();
    return i.splice(s, 1), _objectSpread(_objectSpread({}, e), {}, {
      stack: i
    });
  }
};
class o extends d {
  constructor() {
    super(...arguments);
    p(this, "actions", {
      push: t => this.send({
        type: 0,
        id: t
      }),
      pop: t => this.send({
        type: 1,
        id: t
      })
    });
    p(this, "selectors", {
      isTop: (t, s) => t.stack[t.stack.length - 1] === s,
      inStack: (t, s) => t.stack.includes(s)
    });
  }
  static new() {
    return new o({
      stack: []
    });
  }
  reduce(t, s) {
    return u(s.type, y, t, s);
  }
}
const x = new l(() => o.new());
export { k as ActionTypes, x as stackMachines };